import { useAgencyStatusRefresh } from '../hooks/useAgencyStatusRefresh';

export const AgencyStatusRefresher = () => {
    useAgencyStatusRefresh();
    return null;
};
